import { useEffect, useRef, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";

const KEY = "ib-sound";
const PLAYED = "ib-welcome-played";
const EVENTS = ["pointerdown", "keydown", "touchend", "click"];

export function SoundToggle() {
  const voice = useRef(null);
  const [playing, setPlaying] = useState(false);

  const playVoice = () => {
    const el = voice.current;
    el.volume = 0.9;
    el.currentTime = 0;
    return el.play().then(() => {
      setPlaying(true);
      window.dispatchEvent(new Event("ib-strike"));
    });
  };

  useEffect(() => {
    if (localStorage.getItem(KEY) === "off" || sessionStorage.getItem(PLAYED)) return undefined;
    const stop = () => EVENTS.forEach((e) => window.removeEventListener(e, start));
    function start() {
      playVoice().then(() => { sessionStorage.setItem(PLAYED, "1"); stop(); }).catch(() => {});
    }
    EVENTS.forEach((e) => window.addEventListener(e, start, { passive: true }));
    return stop;
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const toggle = (e) => {
    e.stopPropagation();
    if (playing) {
      voice.current.pause();
      setPlaying(false);
      localStorage.setItem(KEY, "off");
    } else {
      localStorage.setItem(KEY, "on");
      playVoice().catch(() => {});
    }
  };

  const Icon = playing ? Volume2 : VolumeX;
  return (
    <>
      <audio ref={voice} src="/media/welcome-robot.mp3" preload="auto" data-testid="welcome-voice" onEnded={() => setPlaying(false)} />
      <button type="button" onPointerDown={(e) => e.stopPropagation()} onClick={toggle} aria-label={playing ? "Stop welcome message" : "Play welcome message"} data-testid="sound-toggle"
        className="hero-glass fixed z-40 bottom-[calc(1.5rem+env(safe-area-inset-bottom))] left-4 w-10 h-10 sm:left-auto sm:bottom-40 sm:right-8 sm:w-11 sm:h-11 rounded-full border border-ib-steel/30 flex items-center justify-center text-ib-text hover:text-ib-blue transition-colors">
        <Icon className="w-5 h-5" />
        {playing && <span className="absolute inset-0 rounded-full border border-ib-blue/40 animate-ping" />}
      </button>
    </>
  );
}
